import { render, staticRenderFns } from "./AuditoriaConfirmDesassociacaoModal.vue?vue&type=template&id=4152f4b0"
import script from "./AuditoriaConfirmDesassociacaoModal.vue?vue&type=script&lang=js"
export * from "./AuditoriaConfirmDesassociacaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports